import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getFormattedEventHubUrl } from '../../../../infrastructure/utils/common.utils';
import { NO_HUB_URL_CREATED_TEXT, CREATE_URL_TEXT } from '../../event-hubs.text';
import { OpenLinkInNewTabButton } from './open-link-in-new-tab-button';
import { CopyButton } from '../../../global/copy-button/copy-button';
import DefaultButton from '../../../global/default-button/default-button';
import { observer } from 'mobx-react';
import { Permission } from '../../../../api/roles.dao';
import { hasPermission } from '../../../../infrastructure/utils/has-permissions';
import './event-hub-url-section.scss';

type EventHubUrlSectionProps = {
    subdomain: string | null;
    onCreateUrl: () => void;
};

export const EventHubUrlSection: React.FC<EventHubUrlSectionProps> = observer(({ subdomain, onCreateUrl }) => {
    const url = subdomain ? getFormattedEventHubUrl(subdomain) : null;
    const canManageSubdomain = hasPermission(Permission.MANAGE_HUB_SUBDOMAIN);

    return (
        <div className='event-hub-url-section'>
            {url ? (
                <>
                    <OpenLinkInNewTabButton link={url} />
                    <CopyButton
                        withoutIcon
                        copyValue={url}
                        className='event-hub-url-section__copy-button'
                    />
                </>
            ) : (
                <>
                    <span className='event-hub-url-section__message'>
                        <FormattedMessage {...NO_HUB_URL_CREATED_TEXT} />
                    </span>
                    {canManageSubdomain && (
                        <DefaultButton
                            className='create-url-button'
                            text={<FormattedMessage {...CREATE_URL_TEXT} />}
                            onClick={onCreateUrl}
                            modifier='slim'
                        />
                    )}
                </>
            )}
        </div>
    );
});
